import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { QuestionnaireAnswer } from '../models/questionnaire.model';
import { DatabaseService } from './base/database.service';
import { AgentClientsService } from './agent-clients.service';

@Injectable({
  providedIn: 'root',
})
export class Survey_answersService extends DatabaseService<any> {
  constructor(private http: HttpClient, private agentClientsService: AgentClientsService) {
    super('cp_questionnaire_answer');
  }

  async submit(qa: QuestionnaireAnswer) {
    const token = (await this.supabase.auth.getSession()).data.session
      ?.access_token;

    // CPK-4743: repassa o flag de sessão "Simple Questionnaire" (F2) pro lambda,
    // que já grava em history (CPK-4749/4750).
    // CPK-4845: idem para o botão "Arquivos Opcionais" — só o questionário alvo
    // daquela sessão leva o flag agent_file_upload.
    const body = {
      ...qa,
      ...(this.agentClientsService.isSimpleQuestionnaireSession() ? { simple_questionnaire: true } : {}),
      ...(this.agentClientsService.isAgentFileUploadSessionFor(qa.questionnaire_id) ? { agent_file_upload: true } : {}),
    };

    const ret = (await firstValueFrom(
      this.http.post(
        environment.lambdaUrl + '/submit_questionnaire_answer',
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
    )) as any;

    return ret;
  }

  async deleteQa(qaId: string) {
    const token = (await this.supabase.auth.getSession()).data.session
      ?.access_token;

    try {
      const ret = (await firstValueFrom(
        this.http.delete(
          environment.lambdaUrl + '/submit_questionnaire_answer/' + qaId,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
      )) as any;

      return ret;
    } catch (error) {
      console.error('Error deleting QA', error);
      return null;
    }
  }
}
